import { Metamodel } from 'app/model/base/model';
import { IAttribute, IModel } from 'app/model/base/annotation';
import { TabularTypeDataset } from './tabular-type.dataset';
import { MongoDbAtlasLinkedService } from 'app/model/linkedservice/mongo-db-atlas.linkedservice';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import { format } from 'app/shared/utils/string.util';
import { sanitizeAndFormatString, stringIsNullOrEmpty, type IVersioningDataset } from 'shell-models-lib';

@Metamodel.model({
    name: adfModelTypeMap.mongoDbAtlas.datasetType,
    display: [
        format(stringResources.ModelName_DatasetTemplate, stringResources.MongoDb_DisplayText),
        format(stringResources.ModelName_DatasetsTemplate, stringResources.MongoDb_DisplayText)
    ],
    constraints: {
        linkedService: {
            model: MongoDbAtlasLinkedService.MODEL // Linked service redefined
        }
    }
})
export class MongoDbAtlasDataset extends TabularTypeDataset implements IVersioningDataset  {
    public static readonly MODEL: IModel;
    public static readonly DATABASE: IAttribute;
    public static readonly VERSION: IAttribute;

    @Metamodel.attribute({
        display: stringResources.Database,
        templatable: true,
        association: 'DATABASE',
        constraint: {
            validator: (dataset: MongoDbAtlasDataset, database: string) => {
                if (__IS_FABRIC_DPE__ && stringIsNullOrEmpty(database)) {
                    return [
                        {
                            context: dataset,
                            messageType: 'missing',
                            message: () =>
                                sanitizeAndFormatString(
                                    stringResources.RequiredTemplate,
                                    stringResources.Database
                                )
                        }
                    ];
                }
                return undefined;
            }
        }
    })
    public database?: string;

    @Metamodel.attribute({
        display: stringResources.VersionLabel,
        templatable: true,
        association: 'VERSION'
    })
    public version: string = __IS_FABRIC_DPE__ ? '1.1' : undefined;

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
